import {Observable}           from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';

import IPlaybackQuality from '../../../../Solutions/Shared/Interfaces/IPlaybackQuality';

const createPlaybackQualityChangeStream = (
    playbackQuality$: Observable<IPlaybackQuality>
): Observable<IPlaybackQuality> =>
    playbackQuality$
        .pipe(
            distinctUntilChanged((prev, next) => (
                prev.bitrate === next.bitrate &&
                prev.resolution === next.resolution &&
                prev.estimatedBandwidth === next.estimatedBandwidth
            ))
        );

export default createPlaybackQualityChangeStream;